import React, { useState, useEffect, useMemo } from 'react';
import {InputLista, InputEntidad, InputMedioPago, DatePickerCustom, InputTasa, InputSubTasa, FormLabel, Modal, CheckboxButton, CheckboxButtonGroup} from '../../common';
import { ALERT_TYPE, ShowToastMessage, useForm } from '@laramie/ui';
import {object, func, bool, string} from 'prop-types';
import {CloneObject, CompareDates} from '../../../utils/helpers';
import {getDateNow} from '../../../utils/convert';
import { useFormErrors } from '../../hooks/useFormErrors';
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import {useEntidad} from '../../hooks/useEntidad';
import {isEmptyString} from '../../../utils/validator';
import DataTaggerFormRedux from '../DataTaggerFormRedux';
import {TIPS} from "../../../consts/tips";
import {Accordion, FormError} from "../../common";

const DebitoAutomaticoModal = (props) => {

    const entityInit = {
        id: 0,
        idCuenta: 0,
        idTasa: 0,
        idSubTasa: 0,
        idRubro: 0,
        idTipoSolicitudDebitoAutomatico: 0,
        numeroSolicitudDebitoAutomatico: '',
        idMedioPago: 0,
        detalleMedioPago: '',
        fechaDesde: null,
        fechaAlta: null,
        fechaBaja: null,
        debitoAnticipado: false
    };

    //hooks
    const [state, setState] = useState({
        entity: entityInit,
    });

    const [medioPago, setMedioPago] = useState({
        detalleMedioPago: ""
    });

    const mount = () => {
        setState(prevState => {
            return {...prevState, entity: props.data.entity};
        });
        formSet({
            idTasa: props.data.entity.idTasa,
            idSubTasa: props.data.entity.idSubTasa,
            idRubro: props.data.entity.idRubro,
            idTipoSolicitudDebitoAutomatico: props.data.entity.idTipoSolicitudDebitoAutomatico,
            numeroSolicitudDebitoAutomatico: props.data.entity.numeroSolicitudDebitoAutomatico,
            idMedioPago: props.data.entity.idMedioPago,
            fechaDesde: props.data.entity.fechaDesde,
            fechaAlta: props.data.entity.fechaAlta,
            fechaBaja: props.data.entity.fechaBaja,
            debitoAnticipado: props.data.entity.debitoAnticipado
        });
        setMedioPago({
            detalleMedioPago: props.data.entity.detalleMedioPago
        });
    }
    useEffect(mount, [props.data.entity]);

    const [formValues, formHandle, , formSet] = useForm({
        idTasa: 0,
        idSubTasa: 0,
        idRubro: 0,
        idTipoSolicitudDebitoAutomatico: 0,
        numeroSolicitudDebitoAutomatico: '',
        idMedioPago: 0,
        fechaDesde: null,
        fechaAlta: null,
        fechaBaja: null,
        debitoAnticipado: false
    });

    const today = useMemo(() => getDateNow(), []);

    const { errorOf, validate } = useFormErrors(getErrors);

    //handles
    const handleClickAceptar = () => {
        if (!validate()) return;

        let row = CloneObject(state.entity);
        row.idTasa = parseInt(formValues.idTasa);
        row.idSubTasa = parseInt(formValues.idSubTasa);
        row.idRubro = !isEmptyString(formValues.idPersona) ? parseInt(formValues.idRubro) : 0;
        row.idTipoSolicitudDebitoAutomatico = !isEmptyString(formValues.idTipoSolicitudDebitoAutomatico) ? parseInt(formValues.idTipoSolicitudDebitoAutomatico) : 0;
        row.numeroSolicitudDebitoAutomatico = formValues.numeroSolicitudDebitoAutomatico;
        row.idMedioPago = parseInt(formValues.idMedioPago);
        row.detalleMedioPago = medioPago.detalleMedioPago;
        row.fechaDesde = formValues.fechaDesde;
        row.fechaAlta = formValues.fechaAlta;
        row.fechaBaja = formValues.fechaBaja;
        row.debitoAnticipado = formValues.debitoAnticipado;

        props.onConfirm(row);
    };

    //funciones
    function getErrors() {

        const errors = {};

        if (formValues.idTasa <= 0) errors.idTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idSubTasa <= 0) errors.idSubTasa = VALIDATION_MESSAGE.REQUIRED_OPTION;
        if (formValues.idMedioPago <= 0) errors.idMedioPago = VALIDATION_MESSAGE.REQUIRED_OPTION;

        if (formValues.fechaDesde == null) errors.fechaDesde = VALIDATION_MESSAGE.REQUIRED_DATE;
        else if (CompareDates(formValues.fechaDesde, today) > 0) errors.fechaDesde = 'No puede ser posterior a hoy';

        if (formValues.fechaAlta == null) errors.fechaAlta = VALIDATION_MESSAGE.REQUIRED_DATE;
        if (formValues.fechaAlta != null && formValues.fechaBaja != null &&
            CompareDates(formValues.fechaBaja, formValues.fechaAlta) < 0) errors.fechaBaja = 'No puede ser anterior a la fecha de alta';

        return errors;
    }

    return (
        <Modal
            size="lg"
            title={`Débitos automáticos: ${(state.entity.id > 0) ? state.entity.detalleMedioPago : "Nuevo"}`}
            tipName={TIPS.NAME.MODALS.DEBITOS_AUTOMATICOS_MODAL}
            onEscape={() => props.onDismiss()}
            body={(
                            <div className="row">
                                <div className="mb-3 col-12">
                                    <Accordion title="Detalle de solicitud" startOpen={true}>
                                        <div className='row form-basic'>
                                            <div className="mb-3 col-6">
                                                <FormLabel htmlFor="idTasa" required>Tasa</FormLabel>
                                                <InputTasa
                                                    name="idTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idTasa')} />
                                            </div>
                                            <div className="mb-3 col-6">
                                                <FormLabel htmlFor="idSubTasa" required>Sub tasa</FormLabel>
                                                <InputSubTasa
                                                    name="idSubTasa"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idSubTasa') ? 'is-invalid' : ''}`}
                                                    value={formValues.idSubTasa}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    idTasa={formValues.idTasa}
                                                />
                                                <FormError message={errorOf('idSubTasa')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="idRubro" className="form-label">Rubro</label>
                                                <InputEntidad
                                                    name="idRubro"
                                                    tipName={TIPS.NAME.MODALS.RUBRO_MODAL}
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idRubro}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Rubro"
                                                    entidad="Rubro"
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="fechaDesde" required>Fecha desde</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaDesde"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaDesde') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaDesde}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    maxValue={today}
                                                />
                                                <FormError message={errorOf('fechaDesde')} />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <FormLabel htmlFor="idMedioPago" required>Medio de pago</FormLabel>
                                                <InputMedioPago
                                                    name="idMedioPago"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('idMedioPago') ? 'is-invalid' : ''}`}
                                                    idCuenta={state.entity.idCuenta}
                                                    value={formValues.idMedioPago}
                                                    onChange={(event) => {
                                                        const {target} = event;
                                                        const medioPago = (target.row) ? {
                                                            detalleMedioPago: target.row.detalleMedioPago,
                                                        } : {
                                                            detalleMedioPago: ""
                                                        };
                                                        setMedioPago(medioPago);
                                                        formHandle(event);
                                                    }}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('idMedioPago')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <FormLabel htmlFor="fechaAlta" required>Fecha alta</FormLabel>
                                                <DatePickerCustom
                                                    name="fechaAlta"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaAlta') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaAlta}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError message={errorOf('fechaAlta')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="fechaBaja" className="form-label">Fecha baja</label>
                                                <DatePickerCustom
                                                    name="fechaBaja"
                                                    placeholder=""
                                                    className={`form-control ${errorOf('fechaBaja') ? 'is-invalid' : ''}`}
                                                    value={formValues.fechaBaja}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    minValue={formValues.fechaAlta}
                                                />
                                                <FormError message={errorOf('fechaBaja')} />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="idTipoSolicitudDebitoAutomatico"
                                                       className="form-label">Tipo solicitud</label>
                                                <InputLista
                                                    name="idTipoSolicitudDebitoAutomatico"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.idTipoSolicitudDebitoAutomatico}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                    title="Tipo solicitud de débitos automáticos"
                                                    lista="TipoSolicitudDebitoAutomatico"
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-6 col-md-3">
                                                <label htmlFor="numeroSolicitudDebitoAutomatico"
                                                       className="form-label">Número solicitud</label>
                                                <input
                                                    name="numeroSolicitudDebitoAutomatico"
                                                    type="text"
                                                    placeholder=""
                                                    className="form-control"
                                                    value={formValues.numeroSolicitudDebitoAutomatico}
                                                    onChange={formHandle}
                                                    disabled={props.disabled}
                                                />
                                                <FormError />
                                            </div>
                                            <div className="mb-3 col-12 col-md-6">
                                                <CheckboxButtonGroup label="Modalidad">
                                                    <CheckboxButton
                                                        name="debitoAnticipado"
                                                        label="Débito anticipado"
                                                        checked={formValues.debitoAnticipado}
                                                        onChange={formHandle}
                                                        disabled={props.disabled}
                                                    />
                                                </CheckboxButtonGroup>
                                            </div>
                                        </div>
                                    </Accordion>
                                </div>
                                <div className="mb-3 col-12">
                                    <Accordion title="Información adicional">
                                        <DataTaggerFormRedux
                                            title="Información adicional de Debitos Automáticos"
                                            tipName={TIPS.NAME.MODALS.INFORMACION_ADICIONAL_DEBITOS_AUTOMATICOS_MODAL}
                                            processKey={props.processKey}
                                            entidad="DebitoAutomatico"
                                            idEntidad={state.entity.id}
                                            disabled={props.disabled}
                                        />
                                    </Accordion>
                                </div>
                            </div>
            )}
            footer={!props.disabled ? (<>
                                <button className="btn btn-outline-primary" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Cancelar
                                </button>
                                <button className="btn btn-primary" data-dismiss="modal"
                                        onClick={(event) => handleClickAceptar()}>Aceptar
                                </button>
            </>) : (
                                <button className="btn back-button" data-dismiss="modal"
                                        onClick={(event) => props.onDismiss()}>Volver
                                </button>
            )}
            footerClassName={props.disabled ? 'f-align' : ''}
        />
    );
}

DebitoAutomaticoModal.propTypes = {
    processKey: string.isRequired,
    disabled: bool,
    data: object.isRequired,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired,
};

DebitoAutomaticoModal.defaultProps = {
    disabled: false
};

export default DebitoAutomaticoModal;
